export enum EStorageKeys {
    "menuRecentlySearched" = "menuRecentlySearched",
    "menuSettingsOpened" = "menuSettingsOpened",

    "welcomeBannerSeen" = "welcomeBannerSeen",

    "onboardingEnrichedPerson" = "onboarding-enriched-person",
    "onboardingEnrichedBrand" = "onboarding-enriched-brand",
    "justCompletedOnboarding" = "justCompletedOnboarding",

    "templatesTableColVisibility" = "templatesTableColVisibility"
}